import styled, { css } from 'styled-components';
import { getButtonColor, getButtonColorOnHover } from '../../utils/helpers/styles';

export const Container = styled.button`
	grid-column: span ${({ size }) => size || 1};
	border-radius: var(--border-radius-1);
	background-color: ${({ color, variant }) => getButtonColor(color, variant, 'bg')};
	border: 1px solid ${({ color, variant }) => getButtonColor(color, variant, 'border')};
	color: ${({ color, variant }) => getButtonColor(color, variant, 'color')};
	font-size: 15.3px;
	height: 38px;
	text-align: center;
	font-weight: 500;
	cursor: pointer;
	transition: 300ms;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 32px;

	min-width: ${({ minWidth }) => minWidth}px;

	& > div.loader {
		margin-bottom: -2px;
	}

	&:hover {
		transform: translateY(-1px);
		background-color: ${({ color, variant }) => getButtonColorOnHover(color, variant, 'bg')};
		border-color: ${({ color, variant }) => getButtonColorOnHover(color, variant, 'border')};
		color: ${({ color, variant }) => getButtonColorOnHover(color, variant, 'color')};
		box-shadow: 0px 6px 15px #0000ff30;
	}

	${({ disabled }) =>
		disabled &&
		css`
			pointer-events: none !important;
			opacity: 0.7 !important;
			user-select: none;
		`}
`;

export const IconButtonContainer = styled.button`
	background-color: ${({ color, variant }) => getButtonColor(color, variant, 'bg')};
	border: 1px solid ${({ color, variant }) => getButtonColor(color, variant, 'border')};
	color: ${({ color, variant }) => getButtonColor(color, variant, 'color')};
	width: 35px;
	height: 35px;
	min-width: 35px;
	min-height: 35px;
	cursor: pointer;
	transition: 300ms;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 100%;

	& > svg {
		font-size: 19px;
	}

	& > div.loader {
		margin-bottom: -2px;
	}

	&:hover {
		background-color: ${({ color, variant }) => getButtonColorOnHover(color, variant, 'bg')};
		border-color: ${({ color, variant }) => getButtonColorOnHover(color, variant, 'border')};
		color: ${({ color, variant }) => getButtonColorOnHover(color, variant, 'color')};
		box-shadow: 0px 6px 15px #0000ff30;
	}

	${({ disabled }) =>
		disabled &&
		css`
			pointer-events: none !important;
			opacity: 0.7 !important;
			user-select: none;
		`}
`;
